import { AxiosError } from 'axios';

/** Backend `code` values returned in 4xx error bodies (see spec/error-handling.md §Backend error codes). */
export const API_KEY_ERROR_CODES = {
  insufficientPl: 'INSUFFICIENT_PL',
  restApiDisabled: 'REST_API_DISABLED',
  scopeExceedsPl: 'SCOPE_EXCEEDS_PL',
  workspaceNotFound: 'WORKSPACE_NOT_FOUND',
  keyNotFound: 'KEY_NOT_FOUND',
  keyRevoked: 'KEY_REVOKED',
  rateLimitExceeded: 'RATE_LIMIT_EXCEEDED',
} as const;

interface ApiKeyErrorBody {
  code?: string;
}

/** Extracts the backend error `code` from an Axios error, or `null` when absent/non-Axios. */
export const getApiKeyErrorCode = (error: unknown): string | null => {
  if (!(error instanceof AxiosError)) return null;
  const body = error.response?.data as ApiKeyErrorBody | undefined;
  return body?.code ?? null;
};
